export default function Home() {
  return (
    <div className="flex justify-center items-center w-full h-[calc(100vh-150px)] overflow-hidden  bg-white p-[50px] ">
      <img 
        src="/assets/img/robot/robots-04.png" 
        alt="Robot" 
        className="max-h-full max-w-[full] object-contain"
      />
    </div>
  );
}
